import routes from "./routes"

const roleRoutes = {
    ADMIN: routes.ACADEMIC.HOME,
    STUDENT: routes.CLASSES.HOME,
    STAFF: routes.ACADEMIC.HOME,
    TEACHER: routes.CLASSES.HOME,
};
  
export default roleRoutes;
  